import { COMPANY_HOTEL_FRAGMENT } from '@app/model/company_hotel/service/CompanyHotelGraphQLFragments';
import { gql } from 'graphql-request';
import GraphQL from '@app/model/_common/service/GraphQL';
import { BASIC_HOTEL_FRAGMENT, ROOM_MAPPING_FRAGMENT } from '@app/model/hotel/service/HotelGraphQLFragments';
import {
	PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT
} from '@app/model/process-request/service/ProcessRequestGraphQLFragments';


export const FIND_MY_COMPANY_HOTELS_WITH_COMPETITORS_QUERY: GraphQL = {
	name: 'findMyCompanyHotels',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      query findMyCompanyHotels {
          findMyCompanyHotels {
              ...CompanyHotelFields
          }
      }
	`,
};

export const FIND_MY_COMPANY_HOTELS_LITE_QUERY: GraphQL = {
	name: 'findMyCompanyHotelsLite',
	gql: gql`
      query findMyCompanyHotelsLite {
          findMyCompanyHotelsLite {
              id
							webhotelierId
							mainHotelId
							mainHotelName
							mainHotelLocation {
									country {
											id
											name
                  }
									address
									city
              }
								mainHotelRating
								mainHotelRatingType
          }
      }
	`,
};

export const FIND_COMPANY_HOTEL_WITH_COMPETITORS_QUERY: GraphQL = {
	name: 'findCompanyHotel',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      query findCompanyHotel($companyHotelId: Long!) {
          findCompanyHotel(companyHotelId: $companyHotelId) {
              ...CompanyHotelFields
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_MUTATION: GraphQL = {
	name: 'saveCompanyHotel',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      ${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
      mutation saveCompanyHotel($input:CompanyHotelInput!) {
          saveCompanyHotel(input: $input) {
              companyHotel {
                  ...CompanyHotelFields
              }
              rankingExecutions {
                  ...ProcessRequestExecutionStateFields
              }
          }
      }
	`,
};

export const REMOVE_COMPANY_HOTEL_COMPETITORS_GROUP_MUTATION: GraphQL = {
	name: 'removeCompanyHotelCompetitorsGroup',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation removeCompanyHotelCompetitorsGroup($companyHotelId:Long!, $competitorsGroupId:Long!) {
          removeCompanyHotelCompetitorsGroup(companyHotelId: $companyHotelId, competitorsGroupId: $competitorsGroupId) {
              ...CompanyHotelFields
          }
      }
	`,
};

export const CREATE_COMPANY_HOTEL_MUTATION: GraphQL = {
	name: 'createCompanyHotel',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      ${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
      mutation createCompanyHotel($input:CompanyHotelInput!) {
          createCompanyHotel(input: $input) {
              companyHotel {
                  ...CompanyHotelFields
              }
              rankingExecutions {
                  ...ProcessRequestExecutionStateFields
              }
          }
      }
	`,
};


export const DISABLE_COMPANY_HOTEL_MUTATION: GraphQL = {
	name: 'disableCompanyHotel',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation disableCompanyHotel($companyHotelId:Long!) {
          disableCompanyHotel(companyHotelId: $companyHotelId) {
              ...CompanyHotelFields
          }
      }
	`,
};

export const UPDATE_COMPANY_HOTEL_SUBSCRIPTION_LAST_LOGIN_DATE_MUTATION: GraphQL = {
	name: 'updateCompanyHotelSubscriptionLastLoginDate',
	gql: gql`
      mutation updateCompanyHotelSubscriptionLastLoginDate($companyHotelId:Long!) {
          updateCompanyHotelSubscriptionLastLoginDate(companyHotelId: $companyHotelId) {
              exception
							success
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_METARADAR_SETTINGS_MUTATION: GraphQL = {
	name: 'saveCompanyHotelMetaradarSettings',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation saveCompanyHotelMetaradarSettings($companyHotelId:Long!, $input:CompanyHotelMetaradarSettingsInput!) {
          saveCompanyHotelMetaradarSettings(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelFields
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_PARSING_SETTING_MUTATION: GraphQL = {
	name: 'saveCompanyHotelParsingSetting',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation saveCompanyHotelParsingSetting($companyHotelId:Long!, $input:CompanyHotelParsingSettingInput!) {
          saveCompanyHotelParsingSetting(companyHotelId: $companyHotelId, input: $input) {
              ...CompanyHotelFields
          }
      }
	`,
};

export const ENABLE_COMPANY_HOTEL_DATA_PROVIDER_MUTATION: GraphQL = {
	name: 'enableCompanyHotelDataProvider',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation enableCompanyHotelDataProvider($companyHotelId:Long!, $provider:DataProvider!) {
          enableCompanyHotelDataProvider(companyHotelId: $companyHotelId, provider: $provider) {
              ...CompanyHotelFields
          }
      }
	`,
};

export const REORDER_COMPANY_HOTEL_COMPETITORS_MUTATION: GraphQL = {
	name: 'reorderCompanyHotelCompetitors',
	gql: gql`
      mutation reorderCompanyHotelCompetitors($input: CompanyHotelCompetitorsOrderInput!) {
          reorderCompanyHotelCompetitors(input: $input) {
              exception
							success
          }
      }
	`,
};

export const UPDATE_COMPANY_HOTEL_ROOM_MAPPING_TYPE_MUTATION: GraphQL = {
	name: 'updateCompanyHotelRoomMappingType',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation updateCompanyHotelRoomMappingType($companyHotelId: Long!, $hotelId: Long!, $roomId: Long!, $type: HotelRoomMappingType!) {
          updateCompanyHotelRoomMappingType(companyHotelId: $companyHotelId, hotelId: $hotelId, roomId: $roomId, type: $type) {
              ...CompanyHotelFields
          }
      }
	`,
};

export const AUTO_UPDATE_COMPANY_HOTEL_ROOM_MAPPING_TYPES_MUTATION: GraphQL = {
	name: 'autoUpdateCompanyHotelRoomTypes',
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation autoUpdateCompanyHotelRoomTypes($companyHotelId: Long!, $hotelId: Long!) {
          autoUpdateCompanyHotelRoomTypes(companyHotelId: $companyHotelId, hotelId: $hotelId) {
              ...CompanyHotelFields
          }
      }
	`,
};

export const ENRICH_HOTEL_ROOMS_MUTATION: GraphQL = {
	name: 'enrichHotelRooms',
	gql: gql`
      ${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
      mutation enrichHotelRooms($companyHotelId: Long!, $hotelId: Long!) {
          enrichHotelRooms(companyHotelId: $companyHotelId, hotelId: $hotelId) {
              ...ProcessRequestExecutionStateFields
          }
      }
	`,
};

export const SAVE_COMPANY_HOTEL_ROOM_MAPPING_TYPE_CONFIG_MUTATION: GraphQL = {
	name: "saveCompanyHotelRoomMappingTypeConfig",
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation saveCompanyHotelRoomMappingTypeConfig($companyHotelId: Long!, $type: HotelRoomMappingType!, $name: String!) {
          saveCompanyHotelRoomMappingTypeConfig(companyHotelId: $companyHotelId, type: $type, name: $name) {
              ...CompanyHotelFields
          }
      }
	`
}


export const DISABLE_COMPANY_HOTEL_ROOM_MAPPING_TYPE_CONFIG_MUTATION: GraphQL = {
	name: "disableCompanyHotelRoomMappingTypeConfig",
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation disableCompanyHotelRoomMappingTypeConfig($companyHotelId: Long!, $type: HotelRoomMappingType!) {
          disableCompanyHotelRoomMappingTypeConfig(companyHotelId: $companyHotelId, type: $type) {
              ...CompanyHotelFields
          }
      }
	`
}

export const CREATE_COMPANY_HOTEL_COMPETITOR_TAG_MUTATION: GraphQL = {
	name: "createCompanyHotelCompetitorTag",
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation createCompanyHotelCompetitorTag($companyHotelId: Long!, $name: String!, $color: String!) {
          createCompanyHotelCompetitorTag(companyHotelId: $companyHotelId, name: $name, color: $color) {
              ...CompanyHotelFields
          }
      }
	`
}

export const EDIT_COMPANY_HOTEL_COMPETITOR_TAG_MUTATION: GraphQL = {
	name: "editCompanyHotelCompetitorTag",
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation editCompanyHotelCompetitorTag($companyHotelId: Long!, $competitorTagId: Long!, $name: String!, $color: String!) {
          editCompanyHotelCompetitorTag(companyHotelId: $companyHotelId, competitorTagId: $competitorTagId, name: $name, color: $color) {
              ...CompanyHotelFields
          }
      }
	`
}

export const DELETE_COMPANY_HOTEL_COMPETITOR_TAG_MUTATION: GraphQL = {
	name: "deleteCompanyHotelCompetitorTag",
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation deleteCompanyHotelCompetitorTag($companyHotelId: Long!, $competitorTagId: Long!) {
          deleteCompanyHotelCompetitorTag(companyHotelId: $companyHotelId, competitorTagId: $competitorTagId) {
              ...CompanyHotelFields
          }
      }
	`
}

export const ADD_COMPANY_HOTEL_COMPETITOR_TAG_TO_COMPETITOR_MUTATION: GraphQL = {
	name: "addCompanyHotelCompetitorTagToCompetitor",
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation addCompanyHotelCompetitorTagToCompetitor($companyHotelId: Long!, $competitorId: Long!, $competitorTagId: Long!) {
          addCompanyHotelCompetitorTagToCompetitor(companyHotelId: $companyHotelId, competitorId: $competitorId, competitorTagId: $competitorTagId) {
              ...CompanyHotelFields
          }
      }
	`
}

export const REMOVE_COMPANY_HOTEL_COMPETITOR_TAG_FROM_COMPETITOR_MUTATION: GraphQL = {
	name: "removeCompanyHotelCompetitorTagToCompetitor",
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation removeCompanyHotelCompetitorTagToCompetitor($companyHotelId: Long!, $competitorId: Long!, $competitorTagId: Long!) {
          removeCompanyHotelCompetitorTagToCompetitor(companyHotelId: $companyHotelId, competitorId: $competitorId, competitorTagId: $competitorTagId) {
              ...CompanyHotelFields
          }
      }
	`
}

export const SAVE_OR_CREATE_COMPETITORS_GROUP_MUTATION: GraphQL = {
	name: "saveOrCreateCompanyHotelCompetitorsGroup",
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation saveOrCreateCompanyHotelCompetitorsGroup($input: SaveOrCreateCompetitorsGroupInput!) {
          saveOrCreateCompanyHotelCompetitorsGroup(input: $input) {
              ...CompanyHotelFields
          }
      }
	`
}

export const SANITIZE_ROOM_MAPPINGS_MUTATION: GraphQL = {
	name: "sanitizeRoomMappings",
	gql: gql`
      ${COMPANY_HOTEL_FRAGMENT}
      mutation sanitizeRoomMappings($companyHotelId: Long!, $hotelId: Long!) {
          sanitizeRoomMappings(companyHotelId: $companyHotelId, hotelId: $hotelId) {
              ...CompanyHotelFields
          }
      }
	`
}
